/* global gtag */
/* global dataLayer */

const ReactGtag = {
  initialize: (id) =>
    new Promise((resolve) => {
      const script = window.document.createElement("script");
      script.type = "text/javascript";
      script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
      script.async = true;
      script.addEventListener(
        "load",
        () => {
          window.gtag("js", new Date());
          window.gtag("config", id);
          resolve();
        },
        false,
      );
      const head = window.document.getElementsByTagName("head")[0];
      head.appendChild(script);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        dataLayer.push(arguments);
      };
    }),

  sendEvent: (event, options) => {
    if (!gtag) {
      console.warn("Gtag initialize must be called first");
      return null;
    }
    gtag("event", event, options);
  },

  sendPageView: (location) => {
    if (!gtag) {
      console.warn("Gtag initialize must be called first");
      return null;
    }
    gtag("event", "page_view", {
      page_location: location,
    });
  },
};

export default ReactGtag;
